import React, { Component } from "react";
import { Empty, Spin, Button } from "antd";
import { Redirect } from "react-router-dom";
import * as auth from "../utils/Auth";
import { getUserEmail } from "../utils/Auth";

export default class AuthenticationCallback extends Component {
  state = {
    redirectTo: null,
    error: null,
  };

  retryLogin = () => {
    this.setState({ error: null, redirectTo: "/" });
  };

  async componentDidMount() {
    try {
      const redirectTo = await auth.processAuthResults(window.location.href);
      this.setState({ redirectTo });
      getUserEmail();
    } catch (error) {
      this.setState({ error: error.message || "Authentication Failed" });
    }
  }

  render() {
    const { redirectTo, error } = this.state;

    if (error) {
      return (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              height: "100vh",
              justifyContent: "center",
            }}
          >
            <Empty description={`Authentication error: ${error}`} />
            <Button
              type="primary"
              style={{
                color: "#fff",
                backgroundColor: "#E30536",
                borderColor: "#E30536",
              }}
              onClick={() => this.retryLogin()}
            >
              Retry Login
            </Button>
          </div>
        </>
      );
    }

    return redirectTo ? (
      <Redirect to={redirectTo} />
    ) : (
      <div className="fullscreen-loader">
        <Spin />
      </div>
    );
  }
}
